<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-6">
        <label class="ts-text-xs required">{{ $t('supplier.code') }}</label>
        <input
          v-model="model.vendor_code"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('vendor_code') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('vendor_code')"
        >
          {{ errors.first('vendor_code') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="ts-text-xs required">{{ $t('supplier.name') }}</label>
        <input
          v-model="model.vendor_name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('vendor_name') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('vendor_name')"
        >
          {{ errors.first('vendor_name') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="required ts-text-xs">{{
          $t('supplier.contactPerson')
        }}</label>
        <input
          v-model="model.contact_person"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('contact_person') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('contact_person')"
        >
          {{ errors.first('contact_person') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="ts-text-xs">{{ $t('supplier.email') }}</label>
        <input
          v-model="model.contact_email"
          type="email"
          class="form-control"
          :class="{ 'is-invalid': errors.has('contact_email') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('contact_email')"
        >
          {{ errors.first('contact_email') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="required ts-text-xs">{{
          $t('supplier.phoneLine1')
        }}</label>
        <input
          v-model="model.contact_number1"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('contact_number1') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('contact_number1')"
        >
          {{ errors.first('contact_number1') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="ts-text-xs">{{ $t('supplier.phoneLine2') }}</label>
        <input
          v-model="model.contact_number2"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('contact_number2') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('contact_number2')"
        >
          {{ errors.first('contact_number2') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="ts-text-xs">{{ $t('supplier.creditDay') }}</label>
        <input
          type="number"
          v-model.number="model.credit_day"
          :class="{ 'is-invalid': errors.has('credit_day') }"
          class="form-control"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('credit_day')"
        >
          {{ errors.first('credit_day') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="ts-text-xs">{{ $t('supplier.creditAmount') }}</label>
        <input
          type="number"
          v-model.number="model.credit_amount"
          class="form-control"
          :class="{ 'is-invalid': errors.has('credit_amount') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('credit_amount')"
        >
          {{ errors.first('credit_amount') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="ts-text-xs">{{ $t('supplier.bank') }}</label>
        <a-select
          v-model="model.bank_id"
          :options="bankProfiles"
          showSearch
          :filterOption="
            (input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
          "
          class="ts-w-full"
        ></a-select>
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('bank_id')">
          {{ errors.first('bank_id') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="ts-text-xs" :class="model.bank_id ? 'required' : ''">{{
          $t('supplier.accountName')
        }}</label>
        <input
          type="text"
          v-model="model.account_name"
          class="form-control"
          :class="{ 'is-invalid': errors.has('account_name') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('account_name')"
        >
          {{ errors.first('account_name') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="ts-text-xs" :class="model.bank_id ? 'required' : ''">{{
          $t('supplier.accountNumber')
        }}</label>
        <input
          type="text"
          v-model="model.account_number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('account_number') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('account_number')"
        >
          {{ errors.first('account_number') }}
        </div>
      </div>
      <div class="col-md-6">
        <ts-checkbox class="ts-mt-8" v-model="model.is_local">{{
          $t('supplier.isLocal')
        }}</ts-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('supplier.address') }}</label>
        <textarea
          v-model="model.address"
          rows="3"
          class="form-control"
        ></textarea>
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('contact_email')"
        >
          {{ errors.first('address') }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'supplierForm',
  data () {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      model: {
        vendor_id: 0,
        vendor_code: null,
        vendor_name: null,
        address: null,
        contact_person: null,
        contact_number1: null,
        contact_number2: null,
        contact_email: null,
        is_local: false,
        credit_amount: 0,
        credit_day: 0,
        bank_id: null,
        account_name: null,
        account_number: null
      }
    }
  },
  created () {
    this.setEditData()
    this.fetchFormViewModel({
      params: {},
      index: undefined
    })
  },
  computed: {
    ...mapState('supplier/profile', ['edit_data', 'formViewDatas']),
    isUpdate () {
      return !_.isEmpty(this.edit_data)
    },
    bankProfiles () {
      if (this.formViewDatas.bank) {
        return this.formViewDatas.bank.map(el => ({
          label: el.bank_name,
          value: el.bank_id
        }))
      } else return []
    }
  },
  methods: {
    ...mapActions('supplier/profile', ['getFormViewData']),
    async fetchFormViewModel ({ params, index }) {
      this.loading = true
      await this.getFormViewData({
        index: index,
        params: params
      })
      this.loading = false
    },
    onSave () {
      this.waiting = true
      this.$store
        .dispatch('supplier/profile/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate () {
      this.waiting = true
      this.$store
        .dispatch('supplier/profile/update', {
          id: this.model.vendor_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.vendor_id = this.edit_data.vendor_id
        this.model.vendor_code = this.edit_data.vendor_code
        this.model.vendor_name = this.edit_data.vendor_name
        this.model.address = this.edit_data.address
        this.model.contact_person = this.edit_data.contact_person
        this.model.contact_number1 = this.edit_data.contact_number1
        this.model.contact_number2 = this.edit_data.contact_number2
        this.model.contact_email = this.edit_data.contact_email
        this.model.is_local = this.edit_data.is_local
        this.model.credit_day = this.edit_data.credit_day
        this.model.credit_amount = this.edit_data.credit_amount
        this.model.bank_id = this.edit_data.bank_id
        this.model.account_name = this.edit_data.account_name
        this.model.account_number = this.edit_data.account_number
      }
    }
  }
}
</script>
